// Auto-generated by scripts/scan-translation-keys.ts — DO NOT EDIT.
// Re-run with `pnpm --filter @babackapp/return-widget scan:keys`.
// Generated from 252 unique widget keys across apps/return-widget/src.

export type WidgetKeySection =
  | "articles"
  | "common"
  | "confirmation"
  | "gift-card"
  | "home"
  | "reason"
  | "resolution";

export type WidgetKeyDescriptor = {
  key: string;
  section: WidgetKeySection;
  label: string;
};

export const WIDGET_KEYS: readonly WidgetKeyDescriptor[] = [
  { key: "add-other-article.end.cta", section: "articles", label: "Cta" },
  {
    key: "add-other-article.end.description.title",
    section: "articles",
    label: "Description",
  },
  {
    key: "add-other-article.end.description.isOneResolution",
    section: "articles",
    label: "Is One Resolution",
  },
  {
    key: "add-other-article.end.orTitle",
    section: "articles",
    label: "Or Title",
  },
  { key: "add-other-article.end.title", section: "articles", label: "Title" },
  {
    key: "articleSelection.description",
    section: "articles",
    label: "Description",
  },
  {
    key: "articleSelection.noItemTitle",
    section: "articles",
    label: "No Item Title",
  },
  {
    key: "articleSelection.secondTitle",
    section: "articles",
    label: "Second Title",
  },
  { key: "articleSelection.title", section: "articles", label: "Title" },
  {
    key: "articleSelection.uniqueReturnRequest.description",
    section: "articles",
    label: "Description",
  },
  {
    key: "articleSelection.uniqueReturnRequest.title",
    section: "articles",
    label: "Title",
  },
  {
    key: "misc.connectedUserData",
    section: "articles",
    label: "Connected User Data",
  },
  {
    key: "misc.connectedUserData-isReturnable",
    section: "articles",
    label: "Connected User Data is Returnable",
  },
  { key: "misc.continue", section: "articles", label: "Continue" },
  { key: "misc.tracking", section: "articles", label: "Tracking" },
  {
    key: "returnRequest.fulfillmentGroup.disabledHint",
    section: "articles",
    label: "Disabled Hint",
  },
  {
    key: "returnRequest.notReturnable",
    section: "articles",
    label: "Not Returnable",
  },
  {
    key: "returnRequest.outsideReturnWindow",
    section: "articles",
    label: "Outside Return Window",
  },
  {
    key: "returnRequest.status.returnToStoreStatus",
    section: "articles",
    label: "Return To Store Status",
  },
  {
    key: "articleSelection.fulfillmentGroup",
    section: "common",
    label: "Fulfillment Group",
  },
  { key: "endProcess.stateStep", section: "common", label: "State Step" },
  { key: "giftcard.errorDesc", section: "common", label: "Error Desc" },
  { key: "giftcard.errorTitle", section: "common", label: "Error Title" },
  {
    key: "misc.goToPreviousStep",
    section: "common",
    label: "Go To Previous Step",
  },
  {
    key: "orderPortal.error.country-not-supported.description",
    section: "common",
    label: "Description",
  },
  {
    key: "orderPortal.error.country-not-supported.title",
    section: "common",
    label: "Title",
  },
  {
    key: "orderPortal.error.order-expired.description",
    section: "common",
    label: "Description",
  },
  {
    key: "orderPortal.error.order-expired.title",
    section: "common",
    label: "Title",
  },
  {
    key: "orderPortal.error.order-not-found.description",
    section: "common",
    label: "Description",
  },
  {
    key: "orderPortal.error.order-not-found.title",
    section: "common",
    label: "Title",
  },
  {
    key: "orderPortal.error.order-not-fulfilled.description",
    section: "common",
    label: "Description",
  },
  {
    key: "orderPortal.error.order-not-fulfilled.title",
    section: "common",
    label: "Title",
  },
  {
    key: "orderPortal.error.order-not-supported.description",
    section: "common",
    label: "Description",
  },
  {
    key: "orderPortal.error.order-not-supported.title",
    section: "common",
    label: "Title",
  },
  {
    key: "orderPortal.error.pos-order-not-supported.description",
    section: "common",
    label: "Description",
  },
  {
    key: "orderPortal.error.pos-order-not-supported.title",
    section: "common",
    label: "Title",
  },
  {
    key: "orderPortal.error.unknown.description",
    section: "common",
    label: "Description",
  },
  { key: "orderPortal.error.unknown.title", section: "common", label: "Title" },
  { key: "orderPortal.labelsToShow.email", section: "common", label: "Email" },
  {
    key: "orderPortal.labelsToShow.emailTrack",
    section: "common",
    label: "Email Track",
  },
  {
    key: "orderPortal.labelsToShow.emailTrackZip",
    section: "common",
    label: "Email Track Zip",
  },
  {
    key: "orderPortal.labelsToShow.emailZip",
    section: "common",
    label: "Email Zip",
  },
  { key: "orderPortal.labelsToShow.track", section: "common", label: "Track" },
  {
    key: "orderPortal.labelsToShow.trackZip",
    section: "common",
    label: "Track Zip",
  },
  { key: "orderPortal.labelsToShow.zip", section: "common", label: "Zip" },
  { key: "reasons.uploadImage", section: "common", label: "Upload Image" },
  {
    key: "rebuyBanner.onboarding.description",
    section: "common",
    label: "Description",
  },
  { key: "rebuyBanner.onboarding.title", section: "common", label: "Title" },
  { key: "resolutions.discount", section: "common", label: "Discount" },
  { key: "resolutions.discount.months", section: "common", label: "Months" },
  {
    key: "resolutions.discountFreeTransport",
    section: "common",
    label: "Discount Free Transport",
  },
  {
    key: "resolutions.discountWithTransport",
    section: "common",
    label: "Discount With Transport",
  },
  {
    key: "resolutions.exceptReturnToStore",
    section: "common",
    label: "Except Return To Store",
  },
  {
    key: "resolutions.exchangeOtherProduct",
    section: "common",
    label: "Exchange Other Product",
  },
  {
    key: "resolutions.exchangeOtherProductDesc",
    section: "common",
    label: "Exchange Other Product Desc",
  },
  {
    key: "resolutions.exchangeProduct",
    section: "common",
    label: "Exchange Product",
  },
  {
    key: "resolutions.exchangeProductDesc",
    section: "common",
    label: "Exchange Product Desc",
  },
  { key: "resolutions.refundDesc", section: "common", label: "Refund Desc" },
  {
    key: "resolutions.refundDescription",
    section: "common",
    label: "Refund Description",
  },
  { key: "resolutions.return", section: "common", label: "Return" },
  { key: "resolutions.supplement", section: "common", label: "Supplement" },
  {
    key: "resolutions.supplementWithTransport",
    section: "common",
    label: "Supplement With Transport",
  },
  { key: "widget.closeWarning", section: "common", label: "Close Warning" },
  {
    key: "add-other-article.end.description.labelGenerated",
    section: "confirmation",
    label: "Label Generated",
  },
  {
    key: "articleSelection.viewReturnRequest",
    section: "confirmation",
    label: "View Return Request",
  },
  {
    key: "common.backToStore",
    section: "confirmation",
    label: "Back To Store",
  },
  {
    key: "endingArticle.deleteReturn",
    section: "confirmation",
    label: "Delete Return",
  },
  {
    key: "endingArticle.newReturn",
    section: "confirmation",
    label: "New Return",
  },
  {
    key: "endProcess.dropPackageRelay",
    section: "confirmation",
    label: "Drop Package Relay",
  },
  { key: "endProcess.findRelay", section: "confirmation", label: "Find Relay" },
  {
    key: "endProcess.generating",
    section: "confirmation",
    label: "Generating",
  },
  {
    key: "endProcess.labelExpired",
    section: "confirmation",
    label: "Label Expired",
  },
  {
    key: "endProcess.needNotValidationTitle",
    section: "confirmation",
    label: "Need Not Validation Title",
  },
  {
    key: "endProcess.needValidationDesc",
    section: "confirmation",
    label: "Need Validation Desc",
  },
  {
    key: "endProcess.needValidationTitle",
    section: "confirmation",
    label: "Need Validation Title",
  },
  {
    key: "endProcess.notValidate",
    section: "confirmation",
    label: "Not Validate",
  },
  { key: "endProcess.onMap", section: "confirmation", label: "On Map" },
  {
    key: "endProcess.pickupDesc",
    section: "confirmation",
    label: "Pickup Desc",
  },
  {
    key: "endProcess.pickupTitle",
    section: "confirmation",
    label: "Pickup Title",
  },
  {
    key: "endProcess.returnConfirmed",
    section: "confirmation",
    label: "Return Confirmed",
  },
  {
    key: "endProcess.returnConfirmedDesc",
    section: "confirmation",
    label: "Return Confirmed Desc",
  },
  {
    key: "endProcess.returnState",
    section: "confirmation",
    label: "Return State",
  },
  {
    key: "endProcess.returnStore",
    section: "confirmation",
    label: "Return Store",
  },
  {
    key: "endProcess.returnToStore.wrapAndStick",
    section: "confirmation",
    label: "Wrap And Stick",
  },
  {
    key: "endProcess.returnToStoreTitle",
    section: "confirmation",
    label: "Return To Store Title",
  },
  {
    key: "endProcess.schedulePickup",
    section: "confirmation",
    label: "Schedule Pickup",
  },
  {
    key: "endProcess.schedulePickupDesc",
    section: "confirmation",
    label: "Schedule Pickup Desc",
  },
  { key: "endProcess.sending", section: "confirmation", label: "Sending" },
  {
    key: "endProcess.sendPackage",
    section: "confirmation",
    label: "Send Package",
  },
  {
    key: "endProcess.sendPackageWithoutCarrier",
    section: "confirmation",
    label: "Send Package Without Carrier",
  },
  {
    key: "endProcess.sendPackageWithoutCarrierDesc",
    section: "confirmation",
    label: "Send Package Without Carrier Desc",
  },
  {
    key: "endProcess.treatedByLogistic",
    section: "confirmation",
    label: "Treated By Logistic",
  },
  {
    key: "endProcess.treatedDiscountDesc",
    section: "confirmation",
    label: "Treated Discount Desc",
  },
  {
    key: "endProcess.treatedExchangeDesc",
    section: "confirmation",
    label: "Treated Exchange Desc",
  },
  {
    key: "endProcess.treatedReason",
    section: "confirmation",
    label: "Treated Reason",
  },
  {
    key: "endProcess.treatedRefundDesc",
    section: "confirmation",
    label: "Treated Refund Desc",
  },
  {
    key: "endProcess.waitingWithoutPhysicalReturn",
    section: "confirmation",
    label: "Waiting Without Physical Return",
  },
  {
    key: "endProcess.waitingWithoutPhysicalReturnDescription",
    section: "confirmation",
    label: "Waiting Without Physical Return Description",
  },
  { key: "misc.article", section: "confirmation", label: "Article" },
  {
    key: "no-physical-return-explanation.description",
    section: "confirmation",
    label: "Description",
  },
  {
    key: "no-physical-return-explanation.title",
    section: "confirmation",
    label: "Title",
  },
  {
    key: "returnRequest.giftReturn.description",
    section: "confirmation",
    label: "Description",
  },
  {
    key: "returnRequest.giftReturn.label",
    section: "confirmation",
    label: "Label",
  },
  {
    key: "returnRequest.giftReturn.recipientEmailLabel",
    section: "confirmation",
    label: "Recipient Email Label",
  },
  {
    key: "returnRequest.giftReturn.recipientEmailPlaceholder",
    section: "confirmation",
    label: "Recipient Email Placeholder",
  },
  {
    key: "returnRequest.giftReturn.recipientEmailSuffix",
    section: "confirmation",
    label: "Recipient Email Suffix",
  },
  {
    key: "returnRequest.notification.customerNotificationsEnabled",
    section: "confirmation",
    label: "Customer Notifications Enabled",
  },
  { key: "returnRequest.return", section: "confirmation", label: "Return" },
  {
    key: "returnRequest.returnMore",
    section: "confirmation",
    label: "Return More",
  },
  {
    key: "returnRequest.status.approved",
    section: "confirmation",
    label: "Approved",
  },
  {
    key: "returnRequest.status.created",
    section: "confirmation",
    label: "Created",
  },
  {
    key: "returnRequest.status.resolved",
    section: "confirmation",
    label: "Resolved",
  },
  {
    key: "returnRequest.status.shipped",
    section: "confirmation",
    label: "Shipped",
  },
  {
    key: "returnRequest.status.shipping",
    section: "confirmation",
    label: "Shipping",
  },
  {
    key: "returnRequest.status.toApproved",
    section: "confirmation",
    label: "To Approved",
  },
  {
    key: "returnRequest.status.treatedMerchant",
    section: "confirmation",
    label: "Treated Merchant",
  },
  {
    key: "returnRequest.status.waiting",
    section: "confirmation",
    label: "Waiting",
  },
  { key: "returnRequest.tracking", section: "confirmation", label: "Tracking" },
  {
    key: "selectedShop.cannotPrintLabel",
    section: "confirmation",
    label: "Cannot Print Label",
  },
  {
    key: "selectedShop.confirmReturn",
    section: "confirmation",
    label: "Confirm Return",
  },
  {
    key: "selectedShop.transmitReturn",
    section: "confirmation",
    label: "Transmit Return",
  },
  { key: "giftcard.address2", section: "gift-card", label: "Address2" },
  { key: "giftcard.adress", section: "gift-card", label: "Adress" },
  { key: "giftcard.city", section: "gift-card", label: "City" },
  { key: "giftcard.country", section: "gift-card", label: "Country" },
  { key: "giftcard.email", section: "gift-card", label: "Email" },
  { key: "giftcard.firstname", section: "gift-card", label: "Firstname" },
  { key: "giftcard.giftCode", section: "gift-card", label: "Gift Code" },
  { key: "giftcard.index.desc", section: "gift-card", label: "Desc" },
  { key: "giftcard.name", section: "gift-card", label: "Name" },
  { key: "giftcard.phone", section: "gift-card", label: "Phone" },
  { key: "giftcard.returnGift", section: "gift-card", label: "Return Gift" },
  { key: "giftcard.step", section: "gift-card", label: "Step" },
  { key: "giftcard.zip", section: "gift-card", label: "Zip" },
  { key: "endingArticle.legalDoc", section: "home", label: "Legal Doc" },
  { key: "giftcard.iReturnGift", section: "home", label: "I Return Gift" },
  { key: "orderPortal.description", section: "home", label: "Description" },
  { key: "orderPortal.findOrder", section: "home", label: "Find Order" },
  { key: "orderPortal.orderNumber", section: "home", label: "Order Number" },
  { key: "orderPortal.title", section: "home", label: "Title" },
  { key: "returnRequest.cancel", section: "home", label: "Cancel" },
  {
    key: "returnRequest.deleteMessage",
    section: "home",
    label: "Delete Message",
  },
  { key: "returnRequest.deleteTitle", section: "home", label: "Delete Title" },
  { key: "returnRequest.remove", section: "home", label: "Remove" },
  { key: "article.returnReason", section: "reason", label: "Return Reason" },
  {
    key: "article.returnReason.description",
    section: "reason",
    label: "Description",
  },
  {
    key: "article.returnReason.fields.comment.add",
    section: "reason",
    label: "Add",
  },
  {
    key: "article.returnReason.fields.comment.description",
    section: "reason",
    label: "Description",
  },
  {
    key: "article.returnReason.fields.comment.title",
    section: "reason",
    label: "Title",
  },
  {
    key: "article.returnReason.fields.images.description",
    section: "reason",
    label: "Description",
  },
  {
    key: "article.returnReason.fields.images.title",
    section: "reason",
    label: "Title",
  },
  {
    key: "article.returnReason.fields.reason.description",
    section: "reason",
    label: "Description",
  },
  {
    key: "article.returnReason.fields.reason.title",
    section: "reason",
    label: "Title",
  },
  { key: "misc.required", section: "reason", label: "Required" },
  { key: "returnRequest.addPicture", section: "reason", label: "Add Picture" },
  { key: "returnRequest.comment", section: "reason", label: "Comment" },
  {
    key: "returnRequest.commentPlaceholder",
    section: "reason",
    label: "Comment Placeholder",
  },
  { key: "returnRequest.explain", section: "reason", label: "Explain" },
  {
    key: "addressForm.errors.emailInvalid",
    section: "resolution",
    label: "Email Invalid",
  },
  {
    key: "addressForm.errors.phoneInvalid",
    section: "resolution",
    label: "Phone Invalid",
  },
  {
    key: "addressForm.errors.required",
    section: "resolution",
    label: "Required",
  },
  {
    key: "articleBundle.productToDiscount",
    section: "resolution",
    label: "Product To Discount",
  },
  {
    key: "articleBundle.productToExchange",
    section: "resolution",
    label: "Product To Exchange",
  },
  {
    key: "articleBundle.productToExchangeCredit",
    section: "resolution",
    label: "Product To Exchange Credit",
  },
  {
    key: "articleBundle.productToRefund",
    section: "resolution",
    label: "Product To Refund",
  },
  {
    key: "articleBundle.rebuyProduct",
    section: "resolution",
    label: "Rebuy Product",
  },
  { key: "checkout.error.loading", section: "resolution", label: "Loading" },
  { key: "financialLine.bonus", section: "resolution", label: "Bonus" },
  {
    key: "financialLine.exchangeCreditAmount",
    section: "resolution",
    label: "Exchange Credit Amount",
  },
  {
    key: "financialLine.freeShipping",
    section: "resolution",
    label: "Free Shipping",
  },
  {
    key: "financialLine.rebuyAmount",
    section: "resolution",
    label: "Rebuy Amount",
  },
  {
    key: "financialLine.remainingCost",
    section: "resolution",
    label: "Remaining Cost",
  },
  {
    key: "financialLine.reshippingAmount",
    section: "resolution",
    label: "Reshipping Amount",
  },
  {
    key: "financialLine.returnCost",
    section: "resolution",
    label: "Return Cost",
  },
  {
    key: "financialLine.shippingCost",
    section: "resolution",
    label: "Shipping Cost",
  },
  {
    key: "financialLine.subtotalDiscount",
    section: "resolution",
    label: "Subtotal Discount",
  },
  {
    key: "financialLine.subtotalRefund",
    section: "resolution",
    label: "Subtotal Refund",
  },
  { key: "financialLine.taxes", section: "resolution", label: "Taxes" },
  { key: "financialLine.total", section: "resolution", label: "Total" },
  {
    key: "financialLine.totalRefund",
    section: "resolution",
    label: "Total Refund",
  },
  { key: "misc.search", section: "resolution", label: "Search" },
  { key: "openingState.closed", section: "resolution", label: "Closed" },
  {
    key: "openingState.closesSoon",
    section: "resolution",
    label: "Closes Soon",
  },
  { key: "openingState.openNow", section: "resolution", label: "Open Now" },
  { key: "openingState.opensSoon", section: "resolution", label: "Opens Soon" },
  { key: "picking.findDate", section: "resolution", label: "Find Date" },
  {
    key: "picking.findDateDesc",
    section: "resolution",
    label: "Find Date Desc",
  },
  { key: "rebuyBanner.cta", section: "resolution", label: "Cta" },
  {
    key: "rebuyBanner.currencyMismatchAction",
    section: "resolution",
    label: "Currency Mismatch Action",
  },
  {
    key: "rebuyBanner.currencyMismatchMessage",
    section: "resolution",
    label: "Currency Mismatch Message",
  },
  {
    key: "rebuyBanner.description",
    section: "resolution",
    label: "Description",
  },
  { key: "rebuyBanner.title", section: "resolution", label: "Title" },
  {
    key: "rebuyBanner.titleRebuy",
    section: "resolution",
    label: "Title Rebuy",
  },
  { key: "receipt.description", section: "resolution", label: "Description" },
  { key: "receipt.title", section: "resolution", label: "Title" },
  {
    key: "resolutions.confirmDiscount",
    section: "resolution",
    label: "Confirm Discount",
  },
  {
    key: "resolutions.confirmDiscountDescription",
    section: "resolution",
    label: "Confirm Discount Description",
  },
  {
    key: "resolutions.confirmDiscountNoCostDesc",
    section: "resolution",
    label: "Confirm Discount No Cost Desc",
  },
  {
    key: "resolutions.confirmDiscountNoCostTitle",
    section: "resolution",
    label: "Confirm Discount No Cost Title",
  },
  {
    key: "resolutions.confirmExchange",
    section: "resolution",
    label: "Confirm Exchange",
  },
  {
    key: "resolutions.confirmLost",
    section: "resolution",
    label: "Confirm Lost",
  },
  {
    key: "resolutions.confirmRefund",
    section: "resolution",
    label: "Confirm Refund",
  },
  {
    key: "resolutions.confirmRefundDescription",
    section: "resolution",
    label: "Confirm Refund Description",
  },
  {
    key: "resolutions.confirmRefundNoCostDesc",
    section: "resolution",
    label: "Confirm Refund No Cost Desc",
  },
  {
    key: "resolutions.confirmRefundNoCostTitle",
    section: "resolution",
    label: "Confirm Refund No Cost Title",
  },
  {
    key: "resolutions.discountValidity",
    section: "resolution",
    label: "Discount Validity",
  },
  {
    key: "resolutions.discountWithoutValidity",
    section: "resolution",
    label: "Discount Without Validity",
  },
  {
    key: "resolutions.exchange.selectProduct",
    section: "resolution",
    label: "Select Product",
  },
  {
    key: "resolutions.exchangeWithVariant",
    section: "resolution",
    label: "Exchange With Variant",
  },
  {
    key: "resolutions.exchangeWithVariantDisabled",
    section: "resolution",
    label: "Exchange With Variant Disabled",
  },
  {
    key: "resolutions.forcedDiscount",
    section: "resolution",
    label: "Forced Discount",
  },
  {
    key: "resolutions.forcedDiscount.description",
    section: "resolution",
    label: "Description",
  },
  {
    key: "resolutions.forcedDiscount.validity",
    section: "resolution",
    label: "Validity",
  },
  {
    key: "resolutions.forcedRefund",
    section: "resolution",
    label: "Forced Refund",
  },
  {
    key: "resolutions.forcedRefund.description",
    section: "resolution",
    label: "Description",
  },
  {
    key: "resolutions.forcedRemainingCredit.title",
    section: "resolution",
    label: "Title",
  },
  {
    key: "resolutions.freeTransport",
    section: "resolution",
    label: "Free Transport",
  },
  { key: "resolutions.get", section: "resolution", label: "Get" },
  {
    key: "resolutions.recommended",
    section: "resolution",
    label: "Recommended",
  },
  {
    key: "resolutions.restrictedByTag",
    section: "resolution",
    label: "Restricted By Tag",
  },
  {
    key: "resolutions.returnedArticle",
    section: "resolution",
    label: "Returned Article",
  },
  {
    key: "resolutions.selectedReason.title",
    section: "resolution",
    label: "Selected Reason",
  },
  {
    key: "resolutions.selectedReason.description",
    section: "resolution",
    label: "Description",
  },
  { key: "returns.closed", section: "resolution", label: "Closed" },
  { key: "returns.findShop", section: "resolution", label: "Find Shop" },
  { key: "returns.shipping.carrier", section: "resolution", label: "Carrier" },
  {
    key: "returns.shipping.carrierDescription",
    section: "resolution",
    label: "Carrier Description",
  },
  {
    key: "returns.shipping.retractation",
    section: "resolution",
    label: "Retractation",
  },
  {
    key: "returns.shipping.retractationDescription",
    section: "resolution",
    label: "Retractation Description",
  },
  { key: "returns.shipping.store", section: "resolution", label: "Store" },
  {
    key: "returns.shipping.storeDescription",
    section: "resolution",
    label: "Store Description",
  },
  { key: "returns.title", section: "resolution", label: "Title" },
  {
    key: "selectedShop.confirmExchange",
    section: "resolution",
    label: "Confirm Exchange",
  },
  {
    key: "selectedShop.customerInformations.addressDetails",
    section: "resolution",
    label: "Address Details",
  },
  {
    key: "selectedShop.customerInformations.city",
    section: "resolution",
    label: "City",
  },
  {
    key: "selectedShop.customerInformations.company",
    section: "resolution",
    label: "Company",
  },
  {
    key: "selectedShop.customerInformations.confirmInfo",
    section: "resolution",
    label: "Confirm Info",
  },
  {
    key: "selectedShop.customerInformations.country",
    section: "resolution",
    label: "Country",
  },
  {
    key: "selectedShop.customerInformations.email",
    section: "resolution",
    label: "Email",
  },
  {
    key: "selectedShop.customerInformations.firstName",
    section: "resolution",
    label: "First Name",
  },
  {
    key: "selectedShop.customerInformations.lastName",
    section: "resolution",
    label: "Last Name",
  },
  {
    key: "selectedShop.customerInformations.phone",
    section: "resolution",
    label: "Phone",
  },
  {
    key: "selectedShop.customerInformations.yourPhone",
    section: "resolution",
    label: "Your Phone",
  },
  {
    key: "selectedShop.customerInformations.yourStreet",
    section: "resolution",
    label: "Your Street",
  },
  {
    key: "selectedShop.customerInformations.zipCode",
    section: "resolution",
    label: "Zip Code",
  },
  {
    key: "selectedShop.noPricesAvailable",
    section: "resolution",
    label: "No Prices Available",
  },
  { key: "selectedShop.payment", section: "resolution", label: "Payment" },
  {
    key: "selectedShop.shippingMethodChoice",
    section: "resolution",
    label: "Shipping Method Choice",
  },
  { key: "shopNow.cta", section: "resolution", label: "Cta" },
  { key: "shopNow.description", section: "resolution", label: "Description" },
  { key: "shopNow.payCTA", section: "resolution", label: "Pay CTA" },
  { key: "shopNow.title", section: "resolution", label: "Title" },
] as const;
